import { render, staticRenderFns } from "./UsersSelectDialog.vue?vue&type=template&id=2f3b6766&scoped=true&"
import script from "./UsersSelectDialog.vue?vue&type=script&lang=js&"
export * from "./UsersSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./UsersSelectDialog.vue?vue&type=style&index=0&id=2f3b6766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b6766",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDataTable,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3b6766')) {
      api.createRecord('2f3b6766', component.options)
    } else {
      api.reload('2f3b6766', component.options)
    }
    module.hot.accept("./UsersSelectDialog.vue?vue&type=template&id=2f3b6766&scoped=true&", function () {
      api.rerender('2f3b6766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/UsersSelectDialog.vue"
export default component.exports